import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "profile-selector-overlay" }
const _hoisted_2 = { class: "profile-selector-card" }
const _hoisted_3 = { class: "profile-header" }
const _hoisted_4 = { class: "profile-options" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "profile-info" }
const _hoisted_7 = {
  key: 0,
  class: "create-form"
}
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}
const _hoisted_12 = {
  key: 1,
  class: "error-message"
}
const _hoisted_13 = {
  key: 2,
  class: "loading-state"
}

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import type { TeacherProfile, User } from "@/stores/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSelector',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();

const user = computed((): User | null => authStore.user);
const availableProfiles = computed(
  (): TeacherProfile[] => authStore.availableProfiles,
);

const showCreateForm = ref(false);
const newProfileName = ref("");
const creating = ref(false);
const createError = ref("");
const loading = ref(false);
const error = ref("");

const selectProfile = async (profileId: number) => {
  try {
    loading.value = true;
    error.value = "";

    await authStore.selectProfile(profileId);

    // Navigate to assessments after successful profile selection
    await router.push({ name: "assessments" });
  } catch (err) {
    error.value =
      err instanceof Error ? err.message : "Virhe profiilia valittaessa";
  } finally {
    loading.value = false;
  }
};

const createProfile = async () => {
  if (!newProfileName.value.trim()) {
    createError.value = "Profiilin nimi on pakollinen";
    return;
  }

  try {
    creating.value = true;
    createError.value = "";

    const profile = await authStore.createProfile(
      newProfileName.value.trim(),
      {},
    );

    // Automatically select the newly created profile
    await selectProfile(profile.id);

    // Reset form
    showCreateForm.value = false;
    newProfileName.value = "";
  } catch (err) {
    createError.value =
      err instanceof Error ? err.message : "Virhe profiilia luotaessa";
  } finally {
    creating.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Valitse opettajaprofiili", -1)),
        _createElementVNode("p", null, "Kirjauduit sisään tilille \"" + _toDisplayString(user.value?.name || user.value?.email) + "\"", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableProfiles.value, (profile) => {
          return (_openBlock(), _createElementBlock("div", {
            key: profile.id,
            class: "profile-option",
            onClick: ($event: any) => (selectProfile(profile.id))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", null, _toDisplayString(profile.name), 1),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Opettajaprofiili", -1))
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "profile-arrow" }, "→", -1))
          ], 8, _hoisted_5))
        }), 128)),
        _createElementVNode("div", {
          class: "profile-option create-new",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateForm.value = true))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "profile-info" }, [
            _createElementVNode("h3", null, "+ Luo uusi profiilin"),
            _createElementVNode("p", null, "Luo uusi opettajaprofiili")
          ], -1),
          _createElementVNode("div", { class: "profile-arrow" }, "→", -1)
        ]))])
      ]),
      (showCreateForm.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Luo uusi opettajaprofiili", -1)),
            _createElementVNode("div", _hoisted_8, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "profileName" }, "Profiilin nimi:", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "profileName",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newProfileName).value = $event)),
                type: "text",
                placeholder: "Esim. Anna, Jukka, Liisa...",
                maxlength: "50",
                onKeyup: _withKeys(createProfile, ["enter"])
              }, null, 544), [
                [_vModelText, newProfileName.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showCreateForm.value = false)),
                class: "cancel-button"
              }, " Peruuta "),
              _createElementVNode("button", {
                onClick: createProfile,
                disabled: !newProfileName.value.trim() || creating.value,
                class: "create-button"
              }, _toDisplayString(creating.value ? "Luodaan..." : "Luo profiilin"), 9, _hoisted_10)
            ]),
            (createError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(createError.value), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("div", { class: "loading-spinner" }, null, -1),
            _createElementVNode("p", null, "Asetetaan profiilin...", -1)
          ]))]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})